import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createProcurementPlan,
  listProcurementPlans,
} from '@ebalance/proto/bffuser/v1/procurement_plan_service-ProcurementPlanService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 需要調達計画 計画作成 mutation hook。
 *
 * `ProcurementPlanService.CreateProcurementPlan` を叩く。
 * onSuccess で listProcurementPlans を invalidate して一覧に「作成中」を即時反映
 * する (AC-044)。
 */
export function useCreateProcurementPlan(): InvalidatingMutationResultFor<
  typeof createProcurementPlan
> {
  return useInvalidatingMutation(createProcurementPlan, [
    createConnectQueryKey({
      schema: listProcurementPlans,
      cardinality: 'finite',
    }),
  ])
}
